import React from 'react'
import Traduction from 'Components/Traduction'
import Constants from 'EurestoFonction/Constants'
import DataComponent from '../../../DataComponents/index'
import Grid from '@material-ui/core/Grid'
import ApiRequest from 'EurestoApi/ApiRequest'
import EurestoForm from 'Components/Form'
import Utils from 'EurestoFonction/Utils'


const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  constructor (props) {
    super(props)
    const newState = {
      ...props,
      action: props.action,
      key: Utils.getRandomNumber()
    }
    this.state = {
      saveState: { ...EurestoClone(newState)},
      ...newState
    }
  }

  componentDidMount () {
    if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
      this.getFonction()
    }
  }

  getFonction = async () => {
    const result = await ApiRequest(project.api + 'commun', {
      requete: 'fonction',
      action: 'get',
      id: this.state.id
    }, { showAlertError: false })
    if (result && result.code === 1) {
      const newState = {
        defaultLibelle: result.results.libelle && result.results.libelle.length > 0 && result.results.libelle[0].text,
        libelle: result.results.libelle,
        type: result.results.type,
        autorisation: result.results.autorisation,
      }
      this.setState({
        saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
        ...newState,
        key: Utils.getRandomNumber()
      }, this.forceUpdate)
    }
  }

  onChangeState = (e, name) => {
    this.setState({
      [name]: e
    }, this.forceUpdate)
  }

  onCancel = () => {
    this.setState({
      libelle: undefined,
      type: undefined,
      autorisation: undefined,
      key: Utils.getRandomNumber(),
      action: 'add'
    }, () => this.props.onCancel())
  }

  onSave = async (action) => {
    const result = await ApiRequest(project.api + 'commun', {
      requete: 'fonction',
      action: action === 'update' ? 'update' : 'add',
      id: this.state.id,
      libelle: this.state.libelle,
      type: this.state.type,
      autorisation: this.state.autorisation,
    })
    if (result.code === 1) {
      this.onCancel()
    }
  }

  onDelete = async () => {
    const r = await ApiRequest(project.api + 'commun', {
      requete: 'fonction',
      action: 'delete',
      id: this.state.id,
    })
    if (r && r.code === 1) {
      this.setState({
        action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
      })
    }
  }

  onArchive = async () => {
    console.log('not done yet')
  }

  onView = (action) => {
    const newState = this.state.saveState
    newState.saveState = { ...EurestoClone(this.state.saveState) }
      newState.key = Utils.getRandomNumber()
    const keys = Object.keys(this.state)
    const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
    this.setState({
      ...stateReset,
      ...newState
    }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
  }

  form = (disabled, autoFocus) => {
    return (
      <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
            justify="flex-start"
            alignItems="stretch">
        <Traduction
          key={autoFocus}
          autoFocus={autoFocus}
          title={EurestoI18n.t('commun:Nom')}
          onChange={this.onChangeState}
          name={'libelle'}
          disabled={disabled}
          data={this.state.libelle !== undefined ? this.state.libelle : []}
          type={Constants.typeSaisie.SaisieLibre}
        />
        <Traduction
          title={EurestoI18n.t('commun:Type')}
          onChange={this.onChangeState}
          name={'type'}
          disabled={disabled}
          data={this.state.type !== undefined ? this.state.type : []}
          type={Constants.typeSaisie.SaisieLibre}
        />
        <DataComponent
          title={EurestoI18n.t('commun:Autorisation')}
          name="autorisation"
          disabled={disabled}
          type={Constants.typeSaisie.InputTextBasic}
          onChange={this.onChangeState}
          data={this.state.autorisation}
          defineData={true}/>
      </Grid>
    )
  }

  render () {
    return (
      <EurestoForm key={this.state.key}
                   {...this.props.formProps}
                   libelle={this.state.defaultLibelle}
                   action={this.state.action}
                   isAllow={this.props.isAllow}
                   onSave={this.onSave}
                   onCancel={this.onCancel}
                   onDelete={this.onDelete}
                   onArchive={this.onArchive}
                   onView={this.onView}
                   libelleAdd={EurestoI18n.t('commun:Nouvelle fonction')}
                   children={this.form}/>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Configuration/Fonction.js